module.exports = __webpack_public_path__ + "img/bell.abed2705.svg";